import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    logout();
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Link to="/dashboard" className="text-xl font-bold text-primary-600 hover:text-primary-700">
                Hub de Facturación
              </Link>
            </div>
            
            {/* Navegación */}
            <div className="hidden md:block ml-10">
              <div className="flex items-baseline space-x-4">
                <Link
                  to="/dashboard"
                  className={`px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out ${
                    isActive('/dashboard') 
                      ? 'bg-primary-100 text-primary-700' 
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  Dashboard
                </Link>
                <Link
                  to="/clientes"
                  className={`px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out ${
                    isActive('/clientes') 
                      ? 'bg-primary-100 text-primary-700' 
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  Clientes
                </Link>
                <Link
                  to="/import-excel"
                  className={`px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out ${
                    isActive('/import-excel') 
                      ? 'bg-primary-100 text-primary-700' 
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  Importar Excel
                </Link>
                <Link
                  to="/cicla-invoices"
                  className={`px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out ${
                    isActive('/cicla-invoices') 
                      ? 'bg-primary-100 text-primary-700' 
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  Facturas Cicla
                </Link>
                <Link
                  to="/nota-credito"
                  className={`px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out ${
                    isActive('/nota-credito') 
                      ? 'bg-primary-100 text-primary-700' 
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  Notas de Crédito
                </Link>
                <Link
                  to="/pendientes-sicla"
                  className={`px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out ${
                    isActive('/pendientes-sicla') 
                      ? 'bg-primary-100 text-primary-700' 
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  Pendientes SICLA
                </Link>
                <Link
                  to="/reporte-dba-audit-trail-usuarios"
                  className={`px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out ${
                    isActive('/reporte-dba-audit-trail-usuarios') 
                      ? 'bg-primary-100 text-primary-700' 
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  Reporte DbaAuditTrail Usuarios
                </Link>
              </div>
            </div>
          </div>
          
          <div className="flex items-center">
            <div className="ml-4 flex items-center md:ml-6">
              <div className="ml-3 relative">
                <div className="flex items-center space-x-4">
                  <span className="text-gray-700">
                    Bienvenido, {user?.username}
                  </span>
                  <button
                    onClick={handleLogout}
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out"
                  >
                    Cerrar Sesión
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;